<ng-container *transloco="let t">
  <div class="dialog-overlay">
    <section
      class="dialog-container"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="'file-validation-issues-title'"
      [attr.aria-describedby]="'file-validation-issues-description'"
      cdkTrapFocus
      cdkTrapFocusAutoCapture>
      <header class="dialog-header">
        <h2 class="dialog-title" id="file-validation-issues-title">
          {{ t('lang.' + titleKey) }}
        </h2>
        <p class="dialog-subtitle" id="file-validation-issues-description">
          {{ t('lang.' + messageKey) }}
        </p>
      </header>

      <div class="dialog-content">
        <div class="files-list">
          @for (issue of issues; track issue.fileId) {
            <lib-collection-report-file-card
              [fileName]="issue.fileName"
              [sizeBytes]="issue.sizeBytes"
              [status]="
                issue.kind === 'RESOLVABLE'
                  ? 'VALIDATION_RESOLVABLE'
                  : 'VALIDATION_PERMANENT'
              "
              [statusLabel]="
                t(
                  issue.kind === 'RESOLVABLE'
                    ? 'lang.file_validation_resolvable'
                    : 'lang.file_validation_permanent'
                )
              "
              [statusDetail]="issue.reason"
              action="NONE" />
          }
        </div>
      </div>

      <footer class="dialog-footer">
        @if (hasPermanentIssues) {
          <button
            class="secondary-button"
            type="button"
            cdkFocusInitial
            (click)="onBack()">
            {{ t('lang.file_validation_back') | uppercase }}
          </button>
          <button class="danger-button" type="button" (click)="onRemoveFiles()">
            {{ t('lang.' + removeActionKey) | uppercase }}
          </button>
        } @else {
          <button
            class="secondary-button"
            type="button"
            cdkFocusInitial
            (click)="onReviewReports()">
            {{ t('lang.' + reviewActionKey) | uppercase }}
          </button>
        }
      </footer>
    </section>
  </div>
</ng-container>
